import GetAge from './GetAge'

export default GetAge



// WEBPACK FOOTER //
// ./src/legacy/components/GetAge/index.js